import ButtonSize from '@/Enums/ButtonSize.enum';
import { CapturePDFButton } from '@/components/Buttons/CapturePDFButton';
import { getDocumentTitle } from '@/helpers/printing';
import { Box } from '@mui/material';
import { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import AudienceInfo from './AudienceInfo';
import BasicInfo from './BasicInfo';
import CreativeInfo from './CreativeInfo';
import CustomDomainListsInfo from './CustomDomainListsInfo';
import DaypartInfo from './DaypartInfo';
import DealGroupInfo from './DealGroupInfo';
import FrequencyCapsInfo from './FrequencyCapsInfo';
import GeoInfo from './GeoInfo';

const components = [
  BasicInfo,
  CustomDomainListsInfo,
  FrequencyCapsInfo,
  GeoInfo,
  DealGroupInfo,
  AudienceInfo,
  DaypartInfo,
  CreativeInfo,
];

interface IProps {
  index: number;
}

const LineItemFormSummarySection = (props: IProps) => {
  const printContainerRef = useRef<HTMLDivElement | null>(null);

  const handlePrint = useReactToPrint({
    documentTitle: getDocumentTitle('Line Item Summary'),
    content: () => printContainerRef.current,
  });

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        '@media print': { '@page': { margin: '15px', size: 'a4 landscape' } },
      }}
      ref={printContainerRef}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '4px',
        }}
      >
        <span>Line Item Summary</span>
        <CapturePDFButton onClick={handlePrint} size={ButtonSize.Small} />
      </Box>
      {components.map((Component, index) => (
        <Component key={index} {...props} />
      ))}
    </Box>
  );
};

export default LineItemFormSummarySection;
